import React from 'react';
import PropTypes from 'prop-types';
import SellerCard from '@fiverr-private/seller_card';
import PortfolioShowcase from '@fiverr-private/portfolio_showcase';
import FiverrLearn from '@fiverr-private/fiverr_learn';
import ProVerified from '@fiverr-private/pro_verified';
import '@fiverr-private/seller_card/dist/index.css';
import '@fiverr-private/portfolio_showcase/dist/index.css';
import '@fiverr-private/fiverr_learn/dist/index.css';
import '@fiverr-private/pro_verified/dist/index.css';
import SellerProfile from './SellerProfile';
import ScrollTo from './scrollTo';
import './index.scss';

export default function InfoPanel({
    sellerCard,
    proSubCategories,
    portfolioProjects,
    fiverrLearnCourses,
    sellerProfile,
    skillTests,
    onPortfolioClick,
    scrollComponents,
    pageCtxId
}) {
    const hasPortfolioProjects = !!portfolioProjects.portfolioProjectsThumbs.length;
    let aboutRef;

    return (
        <div className="info-column">
            {sellerCard.user.is_pro &&
                <ProVerified pro_sub_categories={proSubCategories}/>}
            <SellerCard {...sellerCard}/>

            {scrollComponents &&
                <ScrollTo scrollComponents={scrollComponents}
                    aboutScrollFunc={() => aboutRef.scrollIntoView({ block: 'start', behavior: 'smooth' })}/>}

            <div ref={(ref) => (aboutRef = ref)}/>
            {hasPortfolioProjects &&
                <PortfolioShowcase {...portfolioProjects} onClick={onPortfolioClick}/>}
            <FiverrLearn courses={fiverrLearnCourses} selfview={false}/>
            <SellerProfile {...sellerProfile}
                skillTests={skillTests}
                biData={{
                    pageCtxId,
                    sellerId: sellerCard.user.id
                }}/>
        </div>
    );
}

InfoPanel.propTypes = {
    sellerCard: PropTypes.object,
    portfolioProjects: PropTypes.object,
    fiverrLearnCourses: PropTypes.array,
    sellerProfile: PropTypes.object,
    onPortfolioClick: PropTypes.func,
    scrollComponents: PropTypes.array,
    pageCtxId: PropTypes.string
};

InfoPanel.defaultProps = {
    sellerCard: {},
    portfolioProjects: {},
    fiverrLearnCourses: [],
    sellerProfile: {},
    pageCtxId: ''
};



// WEBPACK FOOTER //
// ./src/common/InfoPanel/index.js